import PopupNotification from '@/domain/core/PopupNotification';
import { backendApi } from '@/utils/api';
import { getI18n } from 'react-i18next';

export type TPresetPayload = {
	code: string;
	preset: string;
};

const translate = (key: string) => {
	const i18n = getI18n();

	return i18n?.t?.(key) ?? key;
};

export default class Preset {
	public static getPreset = async (code: string) => {
		try {
			const {
				data: { preset },
			} = await backendApi.get<TPresetPayload>(`/presets/${code}`);
			const result = preset || '{}';
			return JSON.parse(result) as { [p: string]: string | string[] };
		} catch (e) {
			PopupNotification.emitter('error', translate('presets.errorReceive'));
			return null;
		}
	};

	public static deletePreset = async (code: string) => {
		try {
			await backendApi.delete(`/presets/delete/${code}`);
		} catch (e) {
			PopupNotification.emitter('error', translate('presets.errorDel'));
		}
	};

	public static deleteAllPreset = async () => {
		try {
			await backendApi.delete(`/presets/deleteAll`);
		} catch (e) {
			PopupNotification.emitter('error', translate('presets.errorDel'));
		}
	};

	public static createPreset = async (payload: TPresetPayload) => {
		try {
			const { data } = await backendApi.post<number>('/presets/create', payload);
			return data;
		} catch (e) {
			PopupNotification.emitter('error', translate('presets.errorCreate'));
			return null;
		}
	};
}
